'use client';

import { styled } from '@linaria/react';

const Container = styled.main`
  margin-top: 12px;
  color: #848d97;
  font-size: 19px;
  font-weight: 500;
  line-height: 1.53;
  letter-spacing: 0.5px;
`;

const H1 = styled.h1`
  margin-top: 8px;
  text-align: left;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CursorDot = styled.span`
  display: inline-block;
  animation: blink 1s step-end infinite;

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

const Cursor = styled.span`
  display: inline-block;
  width: 4px;
  height: 12px;
  background-color: #848d97;
  margin-left: 2px;
  animation: blink 1s step-end infinite;

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

const Loading = () => {
  return (
    <Container>
      <H1>
        <CursorDot>...</CursorDot>
        <Cursor />
      </H1>
    </Container>
  );
};

export default Loading;
